import { useRouter } from "next/router";
import { useEffect } from "react";
import { UseFormReturn, useForm, useWatch } from "react-hook-form";

import PageNav from "../components/common/pageNav.comp";
import Layout from "../components/layouts/layout.comp";
import Error from "../components/reuseables/error.comp";
import { ListSection } from "../components/reuseables/list.comp";
import RewardListComp from "../components/reward/rewardList.comp";
import { useTranslation } from "../core/translation.core";
import useRewardQuery from "../hooks/useRewardQuery.hook";
import { RewardListFilter } from "../types/reward";

export default function RewardsPage() {
  const { t, msg } = useTranslation();

  return (
    <Layout title="Reward Records">
      <>
        <Error />
        <Content />
      </>
    </Layout>
  );
}

const Content = () => {
  const { t, msg } = useTranslation();
  const { query, isReady } = useRouter();
  const methods = useForm<RewardListFilter>({
    defaultValues: {
      page: 1,
      pageSize: 20,
    },
  });

  // sync the page, customerId params back to form hook
  useEffect(() => {
    methods.setValue("page", Number(query.page) || 1);
    methods.setValue("customerId", query.customerId as string);
    // eslint-disable-next-line
  }, [query, isReady]);

  return (
    <>
      <ListSection>
        <RewardListComp methods={methods} />
      </ListSection>
      <Paging methods={methods} />
    </>
  );
};

function Paging({ methods }: { methods: UseFormReturn<RewardListFilter, any> }) {
  const router = useRouter();
  const [pageSize] = useWatch({
    name: ["pageSize"],
    control: methods.control,
  });
  const { data: rewards } = useRewardQuery(methods);

  const total = rewards?.size;

  return (
    <PageNav page={Number(router.query.page) || 1} size={pageSize} total={total ?? 0} pathname="/rewards" query={router.query} />
  );
}
